import { graphql } from 'react-relay';

import { commit } from './commit';

const mutation = graphql`
  mutation createStoreMutation($input: CreateStoreInput!) {
    createStore(input: $input) {
      errors {
        key
        messages
      }
      storeEdge {
        node {
          id
        }
      }
    }
  }
`;

const createStore = (environment, attributes, listsId, args = {}) => {
  const {
    backgroundImage,
    logoImage,
    locationMap,
    ...otherAttributes
  } = attributes;

  const uploadables = {};

  if (backgroundImage) {
    uploadables.brandBackgroundImage = backgroundImage;
  }

  if (logoImage) {
    uploadables.brandLogoImage = logoImage;
  }

  if (locationMap) {
    uploadables.brandLocationMap = locationMap;
  }

  return commit(environment, {
    mutation,
    uploadables,
    variables: {
      input: otherAttributes,
    },
    configs: [
      {
        type: 'RANGE_ADD',
        parentID: listsId,
        edgeName: 'storeEdge',
        connectionInfo: [
          {
            key: 'BrandList_stores',
            rangeBehavior: 'append',
          },
        ],
      },
    ],
    ...args,
  });
};

export default createStore;
